import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { AppleIcon } from '../icons/AppleIcon';
import { WindowsIcon } from '../icons/WindowsIcon';
import { LinuxIcon } from '../icons/LinuxIcon';
import { AndroidIcon } from '../icons/AndroidIcon';
import {
  OperatingSystemName,
  OperatingSystemRequirements,
} from 'functions/src/types/firestore/Game/System';
import { SvgIconProps } from '@mui/material';

export const OS_ICONS_MAP: {
  [key in OperatingSystemName]: (props: SvgIconProps) => JSX.Element;
} = {
  MAC: AppleIcon,
  iOS: AppleIcon,
  WINDOWS: WindowsIcon,
  LINUX: LinuxIcon,
  ANDROID: AndroidIcon,
};

export type GameRequirements = {
  minimumRequirements: OperatingSystemRequirements;
  recommendedRequirements: OperatingSystemRequirements;
};

export type OperatingSystemRequirementsListProps = {
  name: OperatingSystemName;
  requirements: GameRequirements;
};

export function OperatingSystemRequirementsList({
  name,
  requirements,
}: OperatingSystemRequirementsListProps) {
  const requirementsKeys = Object.keys(requirements.minimumRequirements).sort();

  const OSIcon = OS_ICONS_MAP[`${name}`];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        height: '100%',
      }}
    >
      <Box sx={{ marginBottom: '8px' }}>
        <OSIcon sx={{ width: 40, height: 50 }} />
      </Box>

      <Stack direction="column" gap="5px" pt="22px" pr="48px">
        {requirementsKeys.map((requirementKey) => {
          return (
            //TODO: replace index with id
            <Box key={requirementKey}>
              <Typography variant="subtitle1">
                {requirementKey.toUpperCase()}
              </Typography>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
}
